import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AlbumData } from '../types'
import { useParams } from 'react-router-dom'

const GET_ALBUM = gql`
    query GetAlbum($id: ID!) {
        album(documentId: $id) {
            documentId
            title
            type
            release_date
            cover {
                formats
                url
            }
            links {
                documentId
                url
                platform
            }
            artists {
                name
            }
        }
    }
`

export const useAlbum = () => {
    const { id } = useParams<{ id: string }>()
    const { data } = useQuery<AlbumData>(GET_ALBUM, {
        variables: { id },
        skip: !id,
    })

    const album = data?.album || null
    return { album }
}
